import React from 'react';

const FinancesList = () => {
  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="flex justify-between items-center">
        <div>
          <h1 className="text-2xl font-bold text-gray-900">Finanzas y Recaudaciones</h1>
          <p className="text-gray-600">Gestiona pagos, matrículas y mensualidades</p>
        </div>
        <button className="bg-primary-500 hover:bg-primary-600 text-white px-4 py-2 rounded-lg font-medium">
          Nuevo Cobro
        </button>
      </div>

      {/* Content */}
      <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-8">
        <div className="text-center">
          <svg className="w-16 h-16 text-gray-400 mx-auto mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1" />
          </svg>
          <h3 className="text-lg font-medium text-gray-900 mb-2">Gestión Financiera</h3>
          <p className="text-gray-600 mb-6">Este módulo está en desarrollo. Aquí podrás gestionar pagos, cobros y reportes financieros.</p>
          <div className="text-sm text-gray-500">
            Próximamente: Gestión de pagos, matrículas, mensualidades, reportes financieros, estados de cuenta y más.
          </div>
        </div>
      </div>
    </div>
  );
};

export default FinancesList;